import React, { useEffect } from 'react';
import { useRouter, withRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';

import Layout from '../../../src/components/Layout';
import Header from '../../../src/components/Header';
import { fetchPrograms } from '../../../src/actions/programs';
import useDeviceKind from '../../../src/hooks/useDeviceKind';
import PageLoader from 'components/PageLoader';
import Purchased from 'components/Pages/Program/Purchased';

const Program = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const isProgramsLoading = useSelector(state => state.programs.loading);
  const { programId } = router.query;
  const isDesktop = useDeviceKind('desktop');

  useEffect(() => {
    dispatch(fetchPrograms());
  }, []);

  return (
    <SessionAuth>
      <Layout title="Program | GMB Fitness™">
        <Header backTo="/programs" backTitle="Programs" isDisplay={isDesktop} />
        {isProgramsLoading ? <PageLoader /> : <Purchased programId={programId} />}
      </Layout>
    </SessionAuth>
  );
};

export default withRouter(Program);
